//Junais
import httpRequest from './../infrastructure/httphelper'

class AppService{
    
    getDeploymentVersion(){

    }

}

let instance= new AppService();
export default instance;